import React, {Component} from 'react';
import Select from 'react-select';

function extractValue(item) {
    if (item !== null && typeof item === 'object' && item.hasOwnProperty('value')) {
        return item.value;
    }
    return item;
}

class CustomSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {value: props.value};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {value} = this.props;
        if (extractValue(prevProps.value) !== extractValue(value)) {
            this.setState({value});
        }
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        const {options, defaultValue, renderOption = (item) => item.label} = this.props;

        const customStyles = {
            indicatorSeparator: () => ({}),
            indicatorsContainer: () => ({}),
            dropdownIndicator: () => ({}),
            control: () => ({}),
        };

        return (
            <Select
                className="react-select-container"
                classNamePrefix="react-select"
                styles={customStyles}
                defaultValue={defaultValue}
                options={options}
                isSearchable={false}
                formatOptionLabel={renderOption}
                onChange={::this.onChange}
            />
        );
    }
}

export default CustomSelect;
